module.exports = __webpack_public_path__ + "images/default_avatars/waves@2x-e38ee3543b77909e7d45d87e966b0f15.jpg";